import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "../services";
import toast from "react-hot-toast";

const initialState = {
    teacherReport: [],
    loading: false,
    error: null,
};

export const fetchTeacherReport = createAsyncThunk(
    "teacherReport/fetchTeacherReport",
    async (params, { rejectWithValue }) => {
        try {
            // Build query string from params
            const queryParams = new URLSearchParams();
            if (params?.campusId) queryParams.append('campusId', params.campusId);
            if (params?.classId) queryParams.append('classId', params.classId);
            if (params?.sectionId) queryParams.append('sectionId', params.sectionId);
            
            const queryString = queryParams.toString();
            const endpoint = `/api/Teacher/teacher-report${queryString ? `?${queryString}` : ''}`;
            
            const response = await getRequest(endpoint);
            
            if (response.status !== 200) {
                throw new Error("Failed to fetch teacher report");
            }
            
            console.log("Teacher Report API Response:", response.data);
            return response.data?.data || response.data || [];
        } catch (error) {
            console.error("Error in fetchTeacherReport:", error);
            return rejectWithValue(error.message || "Failed to fetch teacher report");
        }
    }
);

const teacherReportSlice = createSlice({
    name: "teacherReport",
    initialState,
    reducers: {
        clearTeacherReport: (state) => {
            state.teacherReport = [];
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTeacherReport.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTeacherReport.fulfilled, (state, action) => {
                state.loading = false;
                state.teacherReport = action.payload || [];
            })
            .addCase(fetchTeacherReport.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                toast.error(action.payload || "Failed to fetch teacher report");
            });
    },
});

export const { clearTeacherReport } = teacherReportSlice.actions;
export default teacherReportSlice.reducer;

